import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: ${props => (props.$fullWidth ? 'stretch' : 'center')};
    ${props =>
        props.$fullWidth
            ? `
        align-self: stretch;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
    `
            : ''}
    color: ${props => {
        return props.theme.dark_mode ? '#fff' : '#252525';
    }};

    h2 {
        font-weight: bold;
        color: ${props => {
            return props.theme.dark_mode ? '#fff' : '#252525';
        }};
    }

    .not-full {
        display: flex;
        justify-content: space-around;
    }
`;

export const ChatCardContainer = styled.div`
    height: 100%;

    .jr-card {
        background: ${props => {
            return props.theme.dark_mode ? '#252525' : '#fff';
        }};

        h1 {
            color: ${props => {
                return props.theme.dark_mode ? '#fff' : '#252525';
            }};
        }
    }

    .card {
        margin-bottom: 0px;
    }

    .area-chart-container {
        .recharts-responsive-container {
            margin-left: -30px;
            margin-bottom: -10px;
        }
    }

    .up-component {
        margin-top: -30px;
    }
`;

export const TableArea = styled.div`
    height: 100%;

    tbody {
        display: block;
        min-height: 150px;
        max-height: 250px;
        overflow-y: auto;

        /* width */
        ::-webkit-scrollbar {
            width: 5px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
            background: #f1f1f1;
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
            background: #888;
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
            background: #555;
        }
    }

    thead,
    tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;

        .col-sm {
            width: 15%;
            max-width: 100px;
        }
    }
`;

export const NullData = styled.div`
    height: 100%;
    width: 100%;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #eee;
    padding: 30px;
    margin-bottom: 30px;
`;
